<template>
  <div class="file">
    <div style="padding: 10px;overflow-y: scroll;margin-left: calc((100% - 1200px) / 2);width: 200px;"
      id="productscroll" :style="'height:' + height">
      <template v-for="item in menu">
        <!-- <div style="padding: 10px 0px;" class="ftitle fbold">{{ item.name }}</div> -->
        <div class="ftext">
          <div v-for="(x, i) in item.children">
            <div v-show="x.name != '不要删'" style="padding:10px 0px;" class="cprimary fbold file falign">
              <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>{{ x.name }}
            </div>
            <div>
              <div v-if="x.name != '定制开发' && w.name != '定制开发' && w.name != '企业邮箱'" @click="getInfo(w)"
                :class="[{ 'mindex': w.ID == mindex }, { 'menu': mindex != w.ID }]"
                style="padding:10px 0px;padding-left: 13px;cursor: pointer;" v-for="(w, j) in x.children">{{ w.name }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- overflow-y: scroll;:style="'height:' + height" -->
    <div style="flex: 1;-ms-overflow-style: none;scrollbar-width: none;">
      <div style="background: #f1f2f6;padding:40px 25px;width: 1000px;" id="productscrollb">
        <div v-if="data.title" class="file falign">
          <div v-if="data.logo"><img style="height: 22px;margin-right: 5px;" :src="action + data.logo"></div>
          <div style="font-size: 22px;" class="fbold">{{ data.title }}</div>
        </div>
        <div v-else class="file falign">
          <div v-if="data.logo"><img :src="action + data.logo"></div>
        </div>
        <div style="margin-top: 26px;font-size: 15px;line-height: 25px;" v-show="data.text">
          {{ data.text }}
          <!--  -->
        </div>
        <div style="margin-top: 38px;" v-if="data.img">
          <!-- width: 100%; -->
          <img style="height: auto;width: 100%;" :src="action + data.img">
        </div>
        <div style="margin-top: 25px;background: #fff;" v-for="x in data.infos">
          <div v-show="x.title" style="padding: 25px;font-size: 22px;margin-left: 5px;text-align: center;"
            class="fbold">
            {{
              x.title }}</div>
          <div v-show="x.text"
            style="font-size: 15px;line-height: 25px;text-align: center;padding:0px 25px;margin-bottom: 30px;">{{ x.text
            }}
          </div>
          <div>
            <!-- width: 100%; -->
            <img style="height: auto;" :src="action + x.img">
          </div>
        </div>
        <!-- <div class="file" style="margin-top: 20px;flex-wrap: wrap;background: #fff;">
        <div style="width: 50%;padding:28px 30px 28px 0px;" v-for="x in card">
          <div class="file">
            <div style="height: 75px;margin-top: 6px;border-left: 3px solid #1e66d1;" class="bprimary"></div>
            <div style="margin-left: 22px;">
              <div style="font-size: 20px;" class="cprimary">{{ x.title }}</div>
              <div class="ftext" style="color:#666;margin-top: 15px;">{{ x.text }}</div>
            </div>
          </div>
          <div style="padding-left: 25px;padding-right: 35px;margin-top: 20px;"><img :src="x.src"></div>
        </div>
      </div> -->
        <!-- <div style="margin-top: 20px;background: #fff;padding:28px 24px;margin-bottom: 20px;">
        <div style="font-size: 23px;text-align: center;">主要功能</div>
        <div style="margin-top: 25px;">
          <table>
            <tbody>
              <tr>
                <td style="width: 300px;"><span style="color:#1e66d1;margin-right: 5px;">&bull;</span>高质量的会议规模和体验</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
export default {
  data() {
    return {
      action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
      mindex: '',
      menu: [],
      data: {},
      height: 'calc(100vh)'
      // card: [
      //   { title: '视频会议', src: require('@/assets/images/xzwm4.jpg'), text: '企业级会议安全保障、确保高性能音视频的同时提供丰富的会议协作能力' },
      //   { title: '会议室Rooms', src: require('@/assets/images/xzwm4.jpg'), text: '会议室(Rooms)与多种硬件设备集成,提供音视频会议、无线投屏、协作白板的一站式会议体验' },
      //   { title: '网络研讨会Webinar', src: require('@/assets/images/xzwm4.jpg'), text: '超大型在线会议,低延时,强互动,易管控,轻松在线举办研讨会、培训会、发布会等大型会议' },
      //   { title: '会议室连接器', src: require('@/assets/images/xzwm4.jpg'), text: '腾讯会议完美兼容H.323/SIP会议系统以及IPPBX集团电话系统,使您的硬件会议室设备、桌面以及会议室硬件话机与腾讯会议无缝衔接' }
      // ]
    }
  },
  created() {
    this.$http('/Product/GetTypeData').then(x => {
      if (x.data.length > 0) {
        var data = getJsonTree(x.data, '', 'pid')
        this.menu = data
        this.load()
      }
    })
    var w = window.innerWidth
    var h = window.innerHeight * 0.18 + window.innerHeight - 80
    if (w < 1550) {
      this.height = h + 'px'
    }
  },
  activated() {
    // this.$http('/Product/GetTypeData').then(x => {
    //   if (x.data.length > 0) {
    //     var data = getJsonTree(x.data, '', 'pid')
    //     this.menu = data
    //     this.load()
    //   }
    // })
    var id = this.$route.query.id
    if (id) this.getInfo({ ID: id })
    else if (this.$route.query.title) {
      this.menu.forEach(item => {
        item.children.forEach(z => {
          z.children.forEach(w => {
            if (w.name == this.$route.query.title) {
              this.getInfo(w)
            }
          })
        })
      });
    }
  },
  methods: {
    load() {
      var id = this.$route.query.id
      if (id) this.getInfo({ ID: id })
      else if (this.$route.query.title) {
        this.menu.forEach(item => {
          item.children.forEach(z => {
            z.children.forEach(w => {
              if (w.name == this.$route.query.title) {
                this.getInfo(w)
              }
            })
          })
        });
      }
      else
        this.getInfo(this.menu[0].children[0].children[0])
    },
    getInfo(x) {
      this.mindex = x.ID
      this.$http('/Product/GetData', { typeid: x.ID }).then(x => {
        if (x.length > 0)
          this.data = x[0]
        else this.data = {}
        var asd = document.getElementById("productscrollb")
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // 平滑滚动
        });
        asd.scrollTo({
          top: 0,
          behavior: 'smooth' // 平滑滚动
        });
      })
    }
  }
}
</script>
<style scoped>
.mindex {
  background: #1e66d1;
  color: #fff;
}

.menu:hover {
  background: #f5f5f5;
  color: #1e66d1;
}

table {
  border: 1px solid #e4e6e8;
  border-right: 1px solid #e4e6e8;
  border-bottom: 1px solid #e4e6e8;
}

td {
  border-left: 1px solid #e4e6e8;
  border-top: 1px solid #e4e6e8;
  width: 20%;
  height: 40px;
  padding: 5px 10px;
  font-size: 13px;
  font-weight: bold;
}

#productscroll::-webkit-scrollbar {
  width: 0px;
}

#productscrollb::-webkit-scrollbar {
  /* width: 0px; */
}
</style>